import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import 'rc-dropdown/assets/index.css';
import { faCheck, faSearch } from '@fortawesome/pro-solid-svg-icons';
import { ThreeDots } from 'react-loader-spinner';

const Index = ({
  value,
  dropdownId,
  selectedId,
  setSelectedId,
  selectedName,
  setSelectedName,
  loadMoreData,
  isLoading,
  setSearchString
}) => {
  const [visible, setVisible] = useState(false);
  const menuRef = useRef();
  const [isAtBottom, setIsAtBottom] = useState(false);

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleChange = (event) => {
    if (event.key != -2) {
      setSelectedId(parseInt(event.key));
      const selectedItem = value.filter((item) => item.id == event.key);
      if (selectedItem.length > 0) setSelectedName(selectedItem[0].name);
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const searchHandler = (e)=>{
    const searchString = e.target.value;
    if (searchString.length === 0) {
      setSearchString('');
      return;
    }
    setSearchString(searchString);
  };

  const handleScroll = () => {
    if (!menuRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = menuRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 5 && !isAtBottom) {
      setIsAtBottom(true);
    }
  };

  useEffect(() => {
    if (isAtBottom) {
      setIsAtBottom(false);
      loadMoreData();
    }
  }, [isAtBottom]);

  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.addEventListener('scroll', debouncedHandleScroll);
      return () => menuRef.current?.removeEventListener('scroll', debouncedHandleScroll);
    }
  }, [visible]);

  const debouncedHandleScroll = debounce(handleScroll, 200);

  const menu = (
    <div
      ref={menuRef}
      className='custom-scrollbar'
    >
      <Menu className='w-100 folder-dropdown' onSelect={(e) => { handleChange(e); setVisible(false); }}>
        <div className="custom-search position-relative mb-3">
          <FontAwesomeIcon icon={faSearch} />
          <input type="text" onChange={(e) => searchHandler(e)} className="form-control" />
        </div>
        <>
          {value.map((item, index) => (
            <MenuItem key={item.id} className={`${item.id == selectedId ? 'selected-value' : ''}`}>
              <div className='form-check d-flex justify-content-between align-items-center'>
                <div className="cursor-pointer">
                  <div className={`${item.id === -2 ?'text-danger':''}`} htmlFor={'check-' + index}>
                    {item.name}{' '}
                  </div>
                </div>
                {item.id == selectedId ? (
                  <div className='px-3'>
                    <FontAwesomeIcon className='green-tick' icon={faCheck} />
                  </div>
                ) : <div></div>}
              </div>
            </MenuItem>
          ))}
          {isLoading && 
          <div className='ml-15'>
            <ThreeDots className='justify-content-center' height='15' width='100' color='grey'></ThreeDots>
          </div>}
        </>
      </Menu>
    </div>
  );

  return (
    <>
      <div id={dropdownId}>
        <Dropdown
          trigger={['click']}
          onVisibleChange={handleVisibleChange}
          visible={visible}
          closeOnSelect={true}
          overlay={menu}
          overlayClassName='dropdown-style'
          animation="slide-up"
          getPopupContainer={() => document.getElementById(dropdownId)}>
          <div className="form-select d-flex align-items-center">
            <div value={selectedId} className={`form-placeholder cursor-pointer overflow-hidden ${selectedName.length > 65 ? ' fs-7' : ''}`}>{selectedName || 'Select an option'}</div>
          </div>
        </Dropdown>
      </div>
    </>
  );
};

Index.propTypes = {
  value: PropTypes.array,
  dropdownId: PropTypes.string,
  selectedId: PropTypes.string,
  setSelectedId: PropTypes.func,
  selectedName: PropTypes.string,
  setSelectedName: PropTypes.func,
  loadMoreData: PropTypes.func,
  isLoading: PropTypes.bool,
  setSearchString: PropTypes.func
};

export default Index;
